module.exports = __webpack_public_path__ + "img/头图en.67ab4df6.png";